import styled from "styled-components"

import {Card} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"
import {H4} from "@irati/ui/src/Typography"

export const StyledButton = styled(Button)`
  margin: 10px 0;
  max-width: 450px;
`

export const StyledH4 = styled(H4)`
  margin-bottom: 40px;
`

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StyledIframe = styled.iframe`
  height: auto;
  min-height: 815px;
  position: relative;
  width: 100%;
  background: white;
`
